import DeprecateAssetModal from './DeprecateAssetModal.container';

export default DeprecateAssetModal;
